import api from "../../../api/axios";

const BASE = "/interdicoescco";
const DEFAULT_LIST_LIMIT = 5000;

export async function listarInterdicoesCco({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  return {
    rows: Array.isArray(data?.data) ?data.data : [],
    meta: data?.meta || { limit, offset },
  };
}

export async function salvarDadosInterdicoesCco(id, payload) {
  const { data } = await api.patch(`${BASE}/${id}`, payload);
  return data?.data || data;
}

export async function finalizarBaixaInterdicoesCco(id) {
  const { data } = await api.patch(`${BASE}/${id}/finalizar`);
  return data?.data || data;
}
